
import axios from "axios";


  // const URL = "https://kironadmapi.azurewebsites.net";
// const URL = 'http://191.252.3.206:8083';
//  const URL = 'http://localhost:8083'; 
  const URL = "https://kironadm.api.kiron.net.br";


const apiAdm = axios.create({
    headers: { "Cache-Control": "max-age=300" },
    timeout: 10000,
    baseURL: URL,
    auth: {
        username: "kiron",
        password: "123456"    
    }
});


export default apiAdm;
